import { useHttpClientDispatchable } from "../../../common/modules/httpClient/hooks/useHttpClientDispatchable";
import { RequestMethodEnum } from "../../../common/modules/httpClient/enums/RequestMethodEnum";

export const useUpdateProjectService = (ref: string) =>
  useHttpClientDispatchable({
    url: `/project/${ref}/update`,
    method: RequestMethodEnum.PATCH,
  });
